import * as React from 'react'
import * as Barcode from 'react-barcode'
import $ from 'jquery'
import { Textfit } from 'react-textfit'
import { observer } from 'mobx-react'
import { Currency } from '../../../../components/Currency'
import './ProductLabel.scss'

export interface Label {
  title: string
  location?: string
  barcode: string
}

export interface ProductLabelProps {
  marginTop: number
  marginBottom: number
  barcodeHeight: number
  title: string
  location?: string
  price: number | null
  barcode: string | null
  shouldDisplayBarcode: boolean
  shouldDisplayBarcodeNumber: boolean
  shouldDisplayPrice: boolean
  useLegacyPrintingStyles: boolean
}

const labelStyles = { height: '17px', marginBottom: '-5px' }
@observer
export class ProductLabel extends React.Component<ProductLabelProps, {}> {
  componentDidMount() {
    this.replaceBarcodeWidthAttributes()
  }

  componentDidUpdate() {
    this.replaceBarcodeWidthAttributes()
  }

  replaceBarcodeWidthAttributes() {
    $('svg').attr('width', '100%')
    $('svg').attr('height', '100%')
    // Allows the barcode to stretch and the y be clipped
    $('svg').attr('preserveAspectRatio', 'xMidYMax slice')
    $('rect').attr('height', '100%')
  }

  render() {
    const props = this.props
    const legacyStyles = props.useLegacyPrintingStyles ? labelStyles : {}

    return (
      <div
        className='product-label'
        style={{
          width: '100%',
          height: '100%',
          marginBottom: `${props.marginBottom}in`,
          marginTop: `${props.marginTop}in`,
          paddingTop: '2px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div>
          {!props.shouldDisplayBarcode && <div style={{ height: '17px' }} />}
          {props.location && (
            <div style={legacyStyles}>
              <Textfit mode='single' max={11}>
                {props.location}
              </Textfit>
            </div>
          )}
          <div style={legacyStyles}>
            <Textfit mode='multi' max={11}>
              {props.title}
            </Textfit>
          </div>
          {props.barcode && props.shouldDisplayBarcode && (
            // Reference: https://github.com/lindell/JsBarcode/issues/192
            <div style={{ paddingLeft: 25, paddingRight: 25, marginTop: '3px' }}>
              <div className='product-label__barcode' style={{ height: props.barcodeHeight }}>
                <Barcode
                  margin={1}
                  value={props.barcode}
                  displayValue={false}
                  width={3}
                  fontSize={10}
                />
              </div>
            </div>
          )}
          {props.shouldDisplayBarcodeNumber && (
            <div style={legacyStyles}>
              <Textfit mode='single' max={11}>
                {props.barcode}
              </Textfit>
            </div>
          )}
          {props.shouldDisplayPrice && (props.price || 0) > 0 && (
            <div style={legacyStyles}>
              <Textfit mode='single' max={11}>
                <Currency centValue={props.price} />
              </Textfit>
            </div>
          )}
        </div>
      </div>
    )
  }
}
